import { PropTypes } from 'react'
import styles from './style.styl'
import _times from 'lodash-es/times'
import classnames from 'classnames'

function LoadingDot({ delay, color, size }) {
  return (
    <div className={classnames(styles.Loading, `delay-${delay}`, size)}
      style={{
        backgroundColor: color
      }}>
    </div>
  )
}

function Loading({ className, style, color, numDots, size }) {
  return (
    <div className={classnames('flex-center', className)} style={style}>
      {_times(numDots).map(i => {
        return <LoadingDot key={i} size={size} delay={i + 1} color={color} />
      })}
    </div>
  )
}
Loading.propTypes = {
  /** Loading dot color */
  color: PropTypes.string,
  /** Number of loading dots to show */
  numDots: PropTypes.number,
  /** Size of the dots */
  size: PropTypes.oneOf(['extra-small', 'small', 'medium', 'large', 'extra-large']),
  className: PropTypes.string,
  style: PropTypes.object,
}
Loading.defaultProps = {
  size: 'medium',
  color: 'white',
  numDots: 3
}

export default Loading



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/Loading/index.js